export default {"src":"/assets/_next/static/media/visa.d4c75a0e.svg","height":324,"width":1000,"blurWidth":0,"blurHeight":0};